module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("This endeavour could never have been accomplished without the courage and generosity of those people who have valiantly shared their stories for the greater good. I am hugely indebted to them all for the additional sacrifices they have made in offering their personal testimonies for this book.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Particular thanks are due to Dr Jane Quinn, Dr Remington Nevin and Bea Coldwell for reviewing the text and providing much-valued advice and encouragement throughout. And I must also express my gratitude to Dr Ashley Croft, Trixie Foster and David Rimmington for all their work in this field.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "15px"
    }
  }, [_vm._v("Above all, I have to acknowledge the support of family and friends who have come to understand the nature of Lariam injuries. Their patience and kind tolerance over many years has been inspirational.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 75
// module chunks = 0